import React, { useState } from "react";
import { Lock } from "lucide-react";
import { ChangePasswordModal } from "./ChangePasswordModal";

export function SecuritySection() {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  return (
    // Inline vertical padding: Tailwind py utilities resolve to 0 inside .v2,
    // so the extra space around the section divider is set here.
    <div className="px-4 sm:px-6" style={{ paddingTop: "34px", paddingBottom: "34px" }}>
      <div className="flex items-center gap-2 mb-6">
        <Lock className="w-5 h-5 text-foreground" />
        <h4 className="text-2xl font-bold text-foreground" style={{ fontWeight: "bold" }}>Security</h4>
      </div>

      <div className="space-y-4 px-0 sm:px-4">
        <div>
          <label className="block text-sm font-medium mb-2 text-muted-foreground" style={{ color: "#334155" }}>
            Password
          </label>
          <div className="flex flex-col xl:flex-row gap-3">
            <input
              type="password"
              disabled
              value="••••••••••••••••••••••••"
              className="flex-1 px-2 h-10 border border-border bg-muted rounded-md text-sm tracking-widest cursor-not-allowed font-normal text-muted-foreground"
            />
            <button
              onClick={() => setIsPasswordModalOpen(true)}
              className="h-10 px-3 rounded-md font-semibold text-sm hover:bg-accent hover:text-accent-foreground transition-colors whitespace-nowrap"
              style={{ color: "var(--v2-action)", borderColor: "var(--v2-action)", borderWidth: "2px", borderStyle: "solid", fontSize: "14px" }}
            >
              Change Password
            </button>
          </div>
          <span className="text-sm block mt-2 mb-2 font-normal text-muted-foreground">
            Use a strong password to keep your account secure.
          </span>
        </div>
      </div>

      <ChangePasswordModal
        open={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
      />
    </div>
  );
}
